import { NgClass, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, RouterLink } from '@angular/router';
import { CommanpageService } from 'src/_lib/service/commanpages.service';
import { CommunicationService } from 'src/_lib/service/communication.service';
import { DynamicThemeClassService } from 'src/_lib/service/dynamic-theme-class.service';
import { SearchByVehicleService } from 'src/_lib/service/search-by-vehicle.service';
import { SearchByVehicleComponent } from 'src/app/templates/search-by-vehicle/search-by-vehicle.component';
import { environment } from 'src/environments/environment.prod';
import { BrowserService } from 'src/_lib/service/browser.service';

@Component({
  selector: 'app-header-my-garage-section',
  templateUrl: './header-my-garage-section.component.html',
  styleUrls: ['./header-my-garage-section.component.scss'],
  standalone: true,
  imports: [NgIf, RouterLink, NgClass]
})
export class HeaderMyGarageSectionComponent implements OnInit {
  vehicleName: string = '';
  username: string | null = null;
  commonImagePath: string = environment.commonImagePath;
  private hideTimeout: any;
  isWishlist: boolean;
  tooltipVisible: boolean = false;
  chTheme2 = environment.chTheme2;
  chTheme3 = environment.chTheme3;
  chTheme6 = environment.chTheme6;
  isSearchByVehicleDisabled: boolean = false;

  constructor(
    private comm: CommunicationService,
    private commanService: CommanpageService,
    public dialog: MatDialog,
    private searchByVehicleService: SearchByVehicleService,
    private router: Router,
    private browser: BrowserService,
    private dynamicThemeClassService: DynamicThemeClassService
  ) { }
  ngOnInit(): void {
    this.comm.showVehicleButton.subscribe(() => {
      const vehicleBtnData = this.commanService.isSearchByVehicleDisabled();
      this.isSearchByVehicleDisabled = vehicleBtnData?.header_link;
    });
   
    this.comm.vehiclenameSubject.subscribe(
      {
    next: (name) => {
          this.vehicleName = name;
    },
    error: (error: Error) => {
          this.vehicleName = '';
          console.error('Custom Error: Unexpected Error while subscribing to vehicle Name', error);
    },
  });
    this.comm.username$.subscribe(name => {
      if (name) {
        this.getLoggedInUserName();
      } else {
        this.username = null;
      }
    });
    this.comm.cacheClear.subscribe(()=>{
      this.getWishItems();
      this.getLoggedInUserName();
    });
  }

  getWishItems(): void {
    const wishItems = +this.browser.localStorage?.getItem('wishlistItem') || 0;
    if (wishItems > 0) {
      this.isWishlist = true;
    } else {
      this.isWishlist = false;
    }
    this.comm.wishlistCount.subscribe(() => {
      const wishItems = +this.browser.localStorage?.getItem('wishlistItem') || 0;
      if (wishItems > 0) {
        this.isWishlist = true;
      } else {
        this.isWishlist = false;
      }
    });
  }

  goToLogin() {
    const currentUrl = this.router.url;
    if (currentUrl === '/checkout') {
      this.comm.triggerCheckoutLoginPopup();
      return;
    }
    this.browser.localStorage?.setItem('redirectAfterLogin', currentUrl);
    this.router.navigate(['/customer-login']);
  }

  getLoggedInUserName(): string | null {
    this.username = this.browser.localStorage?.getItem('Username');
    return this.username;
  }

  openVechicleSearchPopup(): void {
    this.dialog.open(SearchByVehicleComponent, {
      width: '600px',
      panelClass: 'search-by-vehicle-dialog'
    });
  }

  hideTooltip(): void {
    this.hideTimeout = setTimeout(() => {
      this.tooltipVisible = false;
    }, 200);
  }

  showTooltip(): void {
    clearTimeout(this.hideTimeout);
    if (this.username) {
      this.tooltipVisible = true;
    }
  }

  clearVehicle() {
    this.searchByVehicleService.clearVehicleSearch();
  }
   themeClass(divName: string): string {
    return this.dynamicThemeClassService.generateClassName(divName);
  }

}